module.exports = __webpack_public_path__ + "img/error.319bb105.svg";